import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from "redux"
import storage from 'redux-persist/lib/storage'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import userReducer from './user'
import miniMenuReducer from './miniMenu'
import contactPageReducer from './contactsPage'
import companiesPageReducer from './companiesPage'
import productsPageReducer from './productsPage'
import projectsPageReducer from './projectsPage'
import propertiesPageReducer from './propertiesPage'
import transactionsPageReducer from './transactionsPage'
import purchaseOrdersPageReducer from './purchaseOrdersPage'
import rentalContractsPageReducer from './rentalContractsPage'
import newContactsPageReducer from './newContactsPage'

const reducers = combineReducers({
  user: userReducer,
  miniMenu: miniMenuReducer,
  contactsPage: contactPageReducer,
  companiesPage: companiesPageReducer,
  productsPage: productsPageReducer,
  projectsPage: projectsPageReducer,
  propertiesPage: propertiesPageReducer,
  transactionsPage: transactionsPageReducer,
  purchaseOrdersPage: purchaseOrdersPageReducer,
  rentalContractsPage: rentalContractsPageReducer,
  newContactsPage: newContactsPageReducer,
})

// Add a migration object
const migrations = {
  1: (state) => {
    return {
      ...state,
      companiesPage: {
        ...state.companiesPage,
        companyFunctions: [],
      },
    }
  },
  2: (state) => {
    return {
      ...state,
      projectsPage: {
        ...state.projectsPage,
        typesList: [],
      },
    }
  },
  3: (state) => {
    return {
      ...state,
      contactsPage: {
        ...state.contactsPage,
        duplicates: {
          records: [],
          groups: [],
          loading: false,
          lastFetchedAt: null,
        },
      },
      companiesPage: {
        ...state.companiesPage,
        duplicates: {
          records: [],
          groups: [],
          loading: false,
          lastFetchedAt: null,
        },
      },
    }
  },
}

const persistConfig = {
  key: 'vitruvi',
  version: 4,
  storage,
  migrate: (state, version) => {
    // Custom migration function
    let newState = { ...state }
    let currentVersion = version || 1

    while (currentVersion < persistConfig.version) {
      if (migrations[currentVersion]) {
        newState = migrations[currentVersion](newState)
      }
      currentVersion++
    }

    return Promise.resolve(newState)
  },
}

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)
